import SoftwarePage from './SoftwarePage'
import { RoleRoute } from '@/types'
import { SoftwareQsRoute } from '@/routes/software/qs/SoftwareQsGrid.route'
import { SoftwareAdskRoute } from '@/routes/software/adsk/SoftwareAdskGrid.route'
import { SoftwareAltrePiattaformeRoute } from '@/routes/software/altre-piattaforme/SoftwareAltrePiattaformeGrid.route'
import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { redirect } from 'react-router-dom'
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons'
import { CustomizationsPageRoute } from '@/routes/customizations/CustomizationsPage.route'

export const softwareSubRoutes: RoleRoute[] = [
  {
    index: true,
    loader: () => redirect('qs'),
    visible: false,
    allowedRoles: [Roles.Guest],
  },
  SoftwareQsRoute,
  SoftwareAdskRoute,
  SoftwareAltrePiattaformeRoute,
  CustomizationsPageRoute,
]

export const SoftwarePageRoute: RoleRoute = {
  path: 'software',
  element: <SoftwarePage />,
  errorElement: <RouterErrorHandler />,
  children: softwareSubRoutes,
  mainMenuRoute: true,
  text: 'Software',
  faIcon: faLaptopCode,
  handle: {
    crumb: () => ({
      label: 'Software',
      icon: faLaptopCode,
    }),
  },
  allowedRoles: [Roles.Guest],
}
